import { useCallback } from 'react';

import { useSubmit } from 'react-router-dom';

import type { IAddressFormValues } from './addressFormSchema';

export function useDefaultAddressFormSubmit() {
  const submit = useSubmit();
  return useCallback(
    (data: IAddressFormValues) => {
      submit(data, {
        method: 'get',
        action: '/search',
      });
    },
    [submit]
  );
}
